import React from "react";
import { Button } from "@/components/ui/button";
import { useT } from "@/app/localization";

export function ForbiddenPage() {
  const t = useT();
  return (
    <div className="min-h-screen grid place-items-center bg-zinc-50 p-6 text-zinc-950 dark:bg-black dark:text-zinc-50">
      <div className="max-w-md rounded-2xl border border-zinc-200/70 bg-white p-6 shadow-sm dark:border-zinc-800 dark:bg-zinc-950">
        <div className="text-lg font-semibold">{t("operator.shell.forbidden_title")}</div>
        <div className="mt-2 text-sm text-zinc-500 dark:text-zinc-400">
          {t("operator.shell.forbidden_body")}
        </div>
        <div className="mt-4 flex gap-2">
          <Button variant="outline" onClick={() => (window.location.href = "/")}>{t("operator.shell.go_home")}</Button>
          <Button onClick={() => (window.location.href = "/logout")}>{t("operator.user_menu.sign_out")}</Button>
        </div>
      </div>
    </div>
  );
}
